import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"
import { updateNostoTagging, addNativeStylesheets } from "../helpers"
import { SEARCH_ONSITE_TAG_SELECTOR } from "../config"

import SearchHeader from "./SearchHeader"
import Sidebar from "./Sidebar"
import Toolbar from "./Toolbar"
import Products from "./Products"
import Pagination from "./Pagination"
import BottomBanner from "./BottomBanner"
import Loader from "./Loader"
import NoResults from "./NoResults"

export default function Serp() {
    const { query, response: { products }, loading } = useAppState();
    const foundProducts = products && products.total > 0;
    const [ sidebarOpen, setSidebarOpen ] = useState(false);

    useEffect(() => {
        addNativeStylesheets();
    }, [])

    useEffect(() => {
        updateNostoTagging(SEARCH_ONSITE_TAG_SELECTOR, query.query);
    }, [ query.query ])

    useEffect(() => {
        if(!products?.total || !query?.query) return;
        document.title = `Búsqueda: ${products.total} resultados encontrados para "${query.query}" - Mac Center`
    }, [ query.query, products?.total ])

    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen)
    }

    return (
        <>
            <h1 class="visually-hidden">
                Búsqueda: {products?.total ?? 0} resultados encontrados para "{query?.query ?? ''}"
            </h1>
            <div class="ns-serp" data-nosto-element="search">
                <SearchHeader />
                <div class="ns-serp-inner facets-vertical page-width ns-justify-content-center">
                    {foundProducts ? (
                        <>
                        <Sidebar
                            sidebarOpen={sidebarOpen}
                            toggleSidebar={toggleSidebar}
                        />
                        <div class="product-grid-container">
                            <Toolbar toggleSidebar={toggleSidebar} />
                            <div class={`template-search__results collection ${loading ? 'loading' : ''}`}>
                                <Products />
                                <Pagination />
                            </div>
                        </div>
                        </>
                    ) : loading ? (
                        <Loader />
                    ) : (
                        <NoResults />
                    )}
                </div>
            </div>
            <BottomBanner />
        </>
    )
}
